// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** http Imports
import http from "../../common/http.service";

// ** List Of News
export const newsList = createAsyncThunk(
  "news/newsList",
  async () => {
    try {
      const response = await http.get("/news");
      return response?.data?.data;
    } catch (error) {
      throw new Error(error?.message);
    }
  }
);

// ** Get News
export const getNews = createAsyncThunk(
  "news/getNews",
  async (id) => {
    try {
      const response = await http.get("/news/" + id);
       return response?.data?.data;
    } catch (error) {
      throw new Error(error?.message);
    }
  }
);

export const newsSlice = createSlice({
  name: "news",
  initialState: {
    isLoader: false,
    data: [],
    newsData: {},
    newxtIndex : ''
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(newsList.pending, (state, action) => {
      state.isLoader = true;
    });
    builder.addCase(newsList.fulfilled, (state, action) => {
      state.isLoader = false;
      state.data = action.payload;
    });
    builder.addCase(newsList.rejected, (state, action) => {
      state.isLoader = false;
    });
     builder.addCase(getNews.pending, (state, action) => {
      state.isLoader = true;
    });
    builder.addCase(getNews.fulfilled, (state, action) => {
      // console.log(state?.data?.findIndex(res => res._id === action.payload?._id))
      state.isLoader = false;
      state.newsData = action?.payload;
      state.newxtIndex = state?.data?.findIndex(res => res._id === action.payload?._id)
    });
    builder.addCase(getNews.rejected, (state, action) => {
      state.isLoader = false;
    });
  },
});

export default newsSlice.reducer;
